import { render, staticRenderFns } from "./PopupBackground.vue?vue&type=template&id=787ee58a&"
import script from "./PopupBackground.vue?vue&type=script&lang=js&"
export * from "./PopupBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports